import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { itemService } from '@/services/item';
import { ref } from 'vue';

export function useItemSettingList() {
    const canAddNewItem = ref(false);
    const { list, total, fetchList } = useBaseListView({
        request: itemService.setting.list,
        hooks: {
            onSuccess: () => {
                const now = new Date().getTime();
                // already have next item or not
                canAddNewItem.value = !list.value.some(item => item.startTime > now);
            }
        }
    });

    const actions = {
        remove: useCrudActions().confirmAndRemove({
            request: itemService.setting.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, canAddNewItem, fetchList, actions };
}
